// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__Wiati","containerItemsCenter":"Skeleton_containerItemsCenter__3Pj9c"};